module.exports = __webpack_public_path__ + "static/media/bg14.6cdd0e88.jpg";